(() => {
  const configElement = document.getElementById('StarsideLocaleConfig');
  if (!configElement || window.Shopify?.designMode) return;

  let config;
  try {
    config = JSON.parse(configElement.textContent);
  } catch (_error) {
    return;
  }

  const preferenceKey = 'starside-language-preference';
  const languages = config.languages || {};
  const supported = (language) => Object.prototype.hasOwnProperty.call(languages, language);
  const roots = Object.values(languages)
    .map((root) => root.replace(/\/$/, ''))
    .filter(Boolean)
    .sort((a, b) => b.length - a.length);

  const storePath = (path) => {
    const root = roots.find((candidate) => path === candidate || path.startsWith(`${candidate}/`));
    const suffix = root ? path.slice(root.length) || '/' : path;
    if (!/^\/(?:$|pages(?:\/|$)|products(?:\/|$)|collections(?:\/|$)|blogs(?:\/|$)|policies(?:\/|$)|cart(?:\/|$)|search(?:\/|$)|account(?:\/|$))/.test(suffix)) return null;
    return suffix;
  };

  const localizedPath = (path, language) => {
    const suffix = storePath(path);
    if (!suffix || !supported(language)) return null;
    const root = languages[language].replace(/\/$/, '');
    return `${root}${suffix === '/' ? '' : suffix}` || '/';
  };

  const localizedUrl = (raw, language) => {
    if (!raw || raw.startsWith('#') || /^(?:mailto:|tel:|javascript:)/i.test(raw)) return null;
    let url;
    try {
      url = new URL(raw, window.location.href);
    } catch (_error) {
      return null;
    }
    if (url.origin !== window.location.origin) return null;

    if (url.pathname.startsWith('/customer_authentication/')) {
      url.searchParams.set('locale', language);
      const returnTo = url.searchParams.get('return_to');
      if (returnTo) {
        try {
          const path = new URL(returnTo, window.location.origin);
          const localized = path.origin === window.location.origin && localizedPath(path.pathname, language);
          if (localized) {
            path.pathname = localized;
            url.searchParams.set('return_to', `${path.pathname}${path.search}${path.hash}`);
          }
        } catch (_error) {}
      }
    } else {
      const path = localizedPath(url.pathname, language);
      if (!path) return null;
      url.pathname = path;
    }
    return `${url.pathname}${url.search}${url.hash}`;
  };

  const rewrite = (language) => {
    document.querySelectorAll('a[href]').forEach((link) => {
      const next = localizedUrl(link.getAttribute('href'), language);
      if (next && next !== link.getAttribute('href')) link.setAttribute('href', next);
    });
    document.querySelectorAll('form[method="get"][action]').forEach((form) => {
      const next = localizedUrl(form.getAttribute('action'), language);
      if (next && next !== form.getAttribute('action')) form.setAttribute('action', next);
    });
    document.querySelectorAll('[data-product-url]').forEach((element) => {
      const next = localizedUrl(element.getAttribute('data-product-url'), language);
      if (next && next !== element.getAttribute('data-product-url')) element.setAttribute('data-product-url', next);
    });
  };

  const remember = (language) => {
    if (!supported(language)) return;
    try {
      window.localStorage.setItem(preferenceKey, language);
    } catch (_error) {}
  };

  const apply = (language) => {
    if (!supported(language)) return;
    if (language !== config.current) {
      const target = localizedUrl(window.location.href, language);
      if (target && target !== `${window.location.pathname}${window.location.search}${window.location.hash}`) {
        window.location.replace(target);
        return;
      }
    }
    rewrite(language);
  };

  document.addEventListener('click', (event) => {
    const choice = event.target.closest?.('form[action*="/localization"] a[data-value]');
    if (choice) {
      remember(choice.dataset.value);
      return;
    }
    const link = event.target.closest?.('a[href]');
    if (!link) return;
    let preferred;
    try {
      preferred = window.localStorage.getItem(preferenceKey);
    } catch (_error) {}
    const next = localizedUrl(link.getAttribute('href'), supported(preferred) ? preferred : config.current);
    if (next) link.setAttribute('href', next);
  }, true);

  let preferred;
  try {
    preferred = window.localStorage.getItem(preferenceKey);
  } catch (_error) {}
  apply(supported(preferred) ? preferred : config.current);

  window.addEventListener('storage', (event) => {
    if (event.key === preferenceKey) apply(supported(event.newValue) ? event.newValue : config.current);
  });
})();
